var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',[_c('template',{slot:"primary"},[_c('div',[_c('input',{attrs:{"id":_vm.inputId,"type":"text"},domProps:{"value":_vm.coordinates},on:{"input":_vm.updateCoordinates}})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }